import { LinkedRequest, ReferrerInterface } from '../interfaces/referrer';

export class Referrer implements ReferrerInterface {
    IDReferrer?: number;
    Name: string;
    Surname: string;
    Email: string;
    requests?: LinkedRequest[];

    constructor() {
        this.Name = '';
        this.Surname = '';
        this.Email = '';
    }
}
